import SectionHeading from "@/components/base/SectionHeading";
import { whyChooseUs } from "@/mocks/home";

export default function WhyChooseUsSection() {
  return (
    <section id="why-us" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Why Choose Us"
          title="Why Lahari Packers and Movers?"
          subtitle="From the first call to the final box, our trained team makes every move safe, transparent and stress-free."
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {whyChooseUs.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}